import React, { useEffect, useState } from 'react';
import axios from 'axios';
import axiosInstance from "../../../../../axiosInstance";
import { API_URL } from "../../../../../config";

function PaymentStatus() {
  const [sessionDetails, setSessionDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [lockedStatus, setLockedStatus] = useState(null);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");

    const fetchSessionDetails = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(`${API_URL}/getSessionDetails/${sessionId}`);
        const { payment } = response.data;
        setSessionDetails(response.data);
        setPaymentStatus(payment.payment_status);

        setLockedStatus(payment.payment_status);
        setTimeout(() => {
          window.location.href = "/candidate/payments";
        }, 3000);

      } catch (error) {
        console.error("Failed to fetch session:", error);
        setPaymentStatus("failed");
        setTimeout(() => {
          window.location.href = "/candidate/payments";
        }, 3000);
      } finally {
        setLoading(false);
      }
    };

    if (sessionId) {
      fetchSessionDetails();
    }
  }, []);

  if (loading) return <div>Loading session details...</div>;

  return (
    <div className="section-full p-t120 p-b90 site-bg-white tw-pricing-area">
      <div className="container">
        <div style={{ padding: '2rem' }}>
          {lockedStatus === "paid" ? (
            <div style={{ color: 'green' }}>
              <h2>🎉 Payment Successful!</h2>
              <p>Thank you for your purchase.</p>
            </div>
          ) : (
            <div style={{ color: 'red' }}>
              <h2>❌ Payment Failed</h2>
              <p>Something went wrong. Please try again.</p>
            </div>
          )}
          {/* <h3>Session Details:</h3>
       <pre>{JSON.stringify(sessionDetails, null, 2)}</pre> */}
        </div>
      </div>
    </div>

  );
}

export default PaymentStatus;


// import React, { useEffect, useState, useRef } from 'react';
// import axios from 'axios';
// import { API_URL } from "../../../../../config";

// function PaymentStatus() {
//   const [loading, setLoading] = useState(true);
//   const [paymentStatus, setPaymentStatus] = useState(null);
//   const isLocked = useRef(false); // 🧠 Ref stays consistent even across re-renders

//   useEffect(() => {
//     const sessionId = new URLSearchParams(window.location.search).get("session_id");

//     const fetchSessionDetails = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.get(`${API_URL}/getSessionDetails/${sessionId}`);
//         const status = response.data?.payment?.payment_status;

//         if (!isLocked.current) {
//           setPaymentStatus(status === 'paid' ? 'paid' : 'failed');
//           isLocked.current = true; // 🔒 Lock it permanently
//         }

//       } catch (error) {
//         console.error("Failed to fetch session:", error);
//         if (!isLocked.current) {
//           setPaymentStatus("failed");
//           isLocked.current = true;
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (sessionId) {
//       fetchSessionDetails();
//     } else {
//       setPaymentStatus("failed");
//       setLoading(false);
//     }
//   }, []);

//   if (loading) return <div>Loading session details...</div>;

//   return (
//     <div style={{ padding: '2rem' }}>
//       {paymentStatus === "paid" ? (
//         <div style={{ color: 'green' }}>
//           <h2>🎉 Payment Successful!</h2>
//           <p>Thank you for your purchase.</p>
//         </div>
//       ) : (
//         <div style={{ color: 'red' }}>
//           <h2>❌ Payment Failed</h2>
//           <p>Something went wrong. Please try again.</p>
//         </div>
//       )}
//     </div>
//   );
// }

// export default PaymentStatus;
